import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "image default-image" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["alt", "src", "title"]



interface Props {
  description: string;
  url: string;
  imgURL: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    description: null,
    url: null,
    imgURL: null
  },
  setup(__props: any) {

const props = __props as {
  description: string;
  url: string;
  imgURL: string;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("figure", _hoisted_1, [
      _createElementVNode("a", {
        href: props.url,
        target: "_blank"
      }, [
        _createElementVNode("img", {
          alt: props.description,
          src: props.imgURL,
          title: props.description
        }, null, 8, _hoisted_3)
      ], 8, _hoisted_2)
    ])
  ]))
}
}

})